import styles from "./BetaBadge.module.css";

import { isBeta } from "@/config/env";

/** The small "BETA" mark beside the header lockup. Renders nothing at launch
 *  (`VITE_OPSHUB_BETA=false`). */
export function BetaBadge() {
  if (!isBeta()) return null;
  return <span className={styles.badge}>Beta</span>;
}

/** Where beta readers send revisions and comments: Ila at IOG runs the beta QA. */
export const BETA_CONTACT = "ila.benitez@insideoutgroup.com.au";

/** The beta notice under the home-page intro. Same switch. */
export function BetaNote() {
  if (!isBeta()) return null;
  return (
    <p className={styles.note}>
      OpsHub is in beta. Content and features may still change. For any revision or comment, email{" "}
      <a href={`mailto:${BETA_CONTACT}`}>{BETA_CONTACT}</a>.
    </p>
  );
}
